import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useConnectionStatusStyles = makeStyles({
  root: {
    display: 'inline-flex',
    alignItems: 'center',
    columnGap: tokens.spacingHorizontalXS,
    fontSize: tokens.fontSizeBase200,
    ...shorthands.padding('4px', '8px'),
    ...shorthands.borderRadius(tokens.borderRadiusMedium),
  },
  indicator: {
    width: '8px',
    height: '8px',
    ...shorthands.borderRadius('50%'),
  },
  connected: {
    backgroundColor: tokens.colorPaletteGreenBackground3,
  },
  disconnected: {
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
  reconnecting: {
    backgroundColor: tokens.colorPaletteYellowBackground3,
    animationName: {
      '0%': { opacity: 1 },
      '50%': { opacity: 0.3 },
      '100%': { opacity: 1 },
    },
    animationDuration: '1.5s',
    animationIterationCount: 'infinite',
  },
  failed: {
    backgroundColor: tokens.colorPaletteRedBackground3,
  },
});
